import React, { FC, useEffect } from "react";
import { Form, Radio, Input, Row, Col } from "antd";

interface EchsEmergencyTreatmentFormProps {
  form: any;
  loading?: boolean;
  disabled: any;
}

const treatmentConditions = [
  {
    key: "investigations",
    label: "INVESTIGATIONS",
    valuePrefix: "1",
  },
  {
    key: "intensiveCare",
    label: "INTENSIVE CARE",
    valuePrefix: "2",
  },
  {
    key: "medicalManagement",
    label: "MEDICAL MANAGEMENT",
    valuePrefix: "3",
  },
  {
    key: "surgicalManagement",
    label: "SURGICAL MANAGEMENT",
    valuePrefix: "4",
  },
  {
    key: "minorDescription",
    label: "PROCEDURE MINOR DESCRIPTION",
    valuePrefix: "5",
  },
  {
    key: "majorDescription",
    label: "PROCEDURE MAJOR DESCRIPTION",
    valuePrefix: "6",
  },
  {
    key: "proposedOther",
    label: "PROPOSED OTHER",
    valuePrefix: "99",
  },
];

const EchsEmergencyTreatmentForm: FC<EchsEmergencyTreatmentFormProps> = ({
  form,
  loading,
  disabled,
}) => {
  useEffect(() => {
    // Initialize form with default N.M. values
    // const initialValues = treatmentConditions.reduce(
    //   (acc, condition) => ({
    //     ...acc,
    //     [condition.key]: `${condition.valuePrefix}:M`,
    //     [`${condition.key}Value`]: "",
    //   }),
    //   {}
    // );

    const initialValues = treatmentConditions.reduce((acc, condition) => {
      // Special case for medicalManagement
      if (condition.key === "medicalManagement") {
        return {
          ...acc,
          [condition.key]: `${condition.valuePrefix}:Y`,
          [`${condition.key}Value`]: "supportive treatment",
        };
      }

      return {
        ...acc,
        [condition.key]: `${condition.valuePrefix}:M`,
        [`${condition.key}Value`]: "",
      };
    }, {});

    if (
      Object.keys(form.getFieldValue("patientProposedTreatmentData") || {})
        ?.length === 0
    ) {
      form.setFieldsValue({
        patientProposedTreatmentData: initialValues,
      });
    }
  }, [form]);

  const handleChange = (name: string, value: string) => {
    const currentValues =
      form.getFieldValue("patientProposedTreatmentData") || {};
    const [prefix] = value.split(":");
    const isYes = value.toLowerCase().includes("y");

    form.setFieldsValue({
      patientProposedTreatmentData: {
        ...currentValues,
        [name]: value,
        [`${name}Value`]: isYes ? currentValues[`${name}Value`] || "" : "",
      },
    });
  };

  const handleValueChange = (name: string, value: string) => {
    const currentValues =
      form.getFieldValue("patientProposedTreatmentData") || {};
    form.setFieldsValue({
      patientProposedTreatmentData: {
        ...currentValues,
        [`${name}Value`]: value,
      },
    });
  };

  const TreatmentField = ({
    condition,
  }: {
    condition: (typeof treatmentConditions)[0];
  }) => {
    const fieldValue = Form.useWatch(
      ["patientProposedTreatmentData", condition.key],
      form,
    );
    const inputValue = Form.useWatch(
      ["patientProposedTreatmentData", `${condition.key}Value`],
      form,
    );
    const showInput = fieldValue?.toLowerCase()?.includes("y");

    return (
      <Row key={condition.key} gutter={[24, 24]}>
        <Col span={24}>
          <Form.Item label={condition.label} required={false}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item
                  noStyle
                  name={["patientProposedTreatmentData", condition.key]}
                >
                  <Radio.Group
                    onChange={(e) =>
                      handleChange(condition.key, e.target.value)
                    }
                    disabled={disabled}
                  >
                    <Radio value={`${condition.valuePrefix}:Y`}>YES</Radio>
                    <Radio value={`${condition.valuePrefix}:N`}>NO</Radio>
                    <Radio value={`${condition.valuePrefix}:M`}>N.M.</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {showInput && (
                <Col span={12}>
                  <Form.Item
                    noStyle
                    name={[
                      "patientProposedTreatmentData",
                      `${condition.key}Value`,
                    ]}
                  >
                    <Input
                      placeholder={`Enter ${condition.label} Value`}
                      onChange={(e) =>
                        handleValueChange(condition.key, e.target.value)
                      }
                      value={inputValue}
                      disabled={disabled}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Form.Item>
        </Col>
      </Row>
    );
  };

  return (
    <div className="echs-emergency-treatment-form">
      <Form form={form} layout="vertical" requiredMark>
        <div className="form-row col">
          {treatmentConditions.slice(0, 3).map((condition) => (
            <TreatmentField key={condition.key} condition={condition} />
          ))}
        </div>

        <div className="form-row row">
          {treatmentConditions.slice(3, 6).map((condition) => (
            <TreatmentField key={condition.key} condition={condition} />
          ))}
        </div>

        <div className="form-row row">
          {treatmentConditions.slice(6).map((condition) => (
            <TreatmentField key={condition.key} condition={condition} />
          ))}
        </div>
      </Form>
    </div>
  );
};

export default EchsEmergencyTreatmentForm;
